import { ObtieneDias, ObtienePanelesTipoPersonaValidar, ObtieneParametros, ObtieneProcesoActual, ObtieneBancosActual, ObtieneCuentasActual, ObtenerPariedad, ObtenerMonedas, ObtieneParametrosP, ObtieneMensajeBloqueoAcceso, ObtieneParametrosBool } from "../../../application/interactors/Parametros";


export const ObtieneParametrosLogic = (selListaParametros: any, codigoParametro: string) => {
    return ObtieneParametros(selListaParametros, codigoParametro);
}

export const ObtieneParametrosPago = (selListaParametros: any, rut: string, codCarrera: string) => {
    return ObtieneParametrosP(selListaParametros, rut, codCarrera);
}

export const ObtieneDiasLogic = (selListaParametros: any, codigoParametro: string, mes: string) => {
    return ObtieneDias(selListaParametros, codigoParametro, mes);
}

export const ObtienePanelesTipoPersonaValidarLogic = (selListaPaneles: any, codigoNegocio: number) => {
    return ObtienePanelesTipoPersonaValidar(selListaPaneles, codigoNegocio);
}
export const ObtieneProcesoActualLogic = (selListaPaneles: any) => {
    return ObtieneProcesoActual(selListaPaneles);
}
export const ObtieneBancosLogic = (selListaPaneles: any) => {
    return ObtieneBancosActual(selListaPaneles);
}
export const ObtieneCuentasLogic = (selListaPaneles: any) => {
    return ObtieneCuentasActual(selListaPaneles);
}
export const ObtenerMonedasLogic = (selListaPaneles: any) => {
    return ObtenerMonedas(selListaPaneles);
}
export const ObtenerPariedadLogic = (selListaPaneles: any, data: number, fecha: string) => {
    return ObtenerPariedad(selListaPaneles, data, fecha);
}
export const ObtieneMensajeBloqueoAccesoLogic = (selMensajeBloqueoAcceso: any) => {
    return ObtieneMensajeBloqueoAcceso(selMensajeBloqueoAcceso);
}
export const ObtieneParametrosBoolLogic = (selListaParametros: any, codigoParametro: string) => {
    return ObtieneParametrosBool(selListaParametros, codigoParametro);
}